import { api } from '../middleware/api';
import { sseClient } from '../../services/sseClient';

export interface HKPublicCleaning {
  cl_id?: number;
  cl_company: string;
  cl_date: string;
  cl_no?: string;
  cl_place: number;
  cl_employee: number;
  cl_statusfrom?: string;
  cl_statusto: string;
  cl_checklist?: string;
  cl_narr?: string;
  cl_inspected_by?: number;
  cl_rating?: string;
  cl_flag?: string;
  cl_uid?: string;
  pl_name?: string;
  pl_type?: string;
  pl_floor?: string;
  cleaner_name?: string;
  inspector_name?: string;
}

export interface PublicCleaningQueryParams {
  company: string;
  fromDate?: string;
  toDate?: string;
  placeId?: number | string;
  employeeId?: number | string;
}

export const hkpubliccleaningApi = api
  .enhanceEndpoints({ addTagTypes: ['HKPublicCleaning', 'HKPublicPlace'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPublicCleanings: builder.query<
        HKPublicCleaning[],
        PublicCleaningQueryParams
      >({
        query: ({ company, fromDate, toDate, placeId, employeeId }) => {
          const params = new URLSearchParams();
          if (fromDate) params.append('fromDate', fromDate);
          if (toDate) params.append('toDate', toDate);
          if (placeId) params.append('placeId', String(placeId));
          if (employeeId) params.append('employeeId', String(employeeId));
          const qs = params.toString();
          return `hkpubliccleaning/${company}${qs ? `?${qs}` : ''}`;
        },
        providesTags: ['HKPublicCleaning'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener((data) => {
              if (
                data.type === 'FRONT_OFFICE_UPDATED' ||
                data.type === 'PUBLIC_CLEANING_UPDATED'
              ) {
                dispatch(
                  hkpubliccleaningApi.util.invalidateTags([
                    'HKPublicCleaning',
                    'HKPublicPlace'
                  ])
                );
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      insertPublicCleaning: builder.mutation<
        HKPublicCleaning,
        Partial<HKPublicCleaning>
      >({
        query: (body) => ({
          url: 'hkpubliccleaning/',
          method: 'POST',
          body
        }),
        invalidatesTags: ['HKPublicCleaning', 'HKPublicPlace']
      }),
      deletePublicCleaning: builder.mutation<void, number>({
        query: (id) => ({
          url: `hkpubliccleaning/${id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['HKPublicCleaning', 'HKPublicPlace']
      })
    }),
    overrideExisting: true
  });

export const {
  useGetPublicCleaningsQuery,
  useInsertPublicCleaningMutation,
  useDeletePublicCleaningMutation
} = hkpubliccleaningApi;
